module.exports = __webpack_public_path__ + "img/illu-dandelion.dad4d649.svg";